import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../main/main.styles';
import { mixinScreen } from '../../styles';

export const IndividualProjectStyles = css`
  ${MainStyles}
  :host {
    ${mixinScreen('flex')}

    align-items: center;
    justify-content: center;
    flex-direction: column;

    --neutral-stroke-divider-rest: var(--neutral-fill-stealth-rest);
  }

  .individual-project {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 16px;
  }

  .individual-project-tab {
    height: 100%;
  }

  .no-padding-card {
    padding: 0;
  }

  zero-tabs {
    height: 100%;
    overflow: auto;
  }

  .project-drilldown-tab {
    height: 100%;
  }

  vppa-modal {
    display: contents;
  }

  cancel-modal {
    display: contents;
  }
  
  project-modal { 
    display: contents;
  }
  
  more-info-modal {
    display: contents;
  }
`;
